import React from 'react'

const ButtonRight = () => {
    return (
        <>
            {/* <button className='bg-[#00A884] inline-flex items-center justify-center rounded-full py-4 px-10 text-center text-base font-normal text-white hover:bg-opacity-90 lg:px-8 xl:px-10'>
                Get Started
            </button> */}

            <button
                className="inline-block rounded-[15px] w-full h-11  bg-[#00A884] mt-4 text-sm font-semibold  leading-normal text-white shadow-md transition duration-150 ease-in-out
                 hover:bg-[#0F8E73] active:bg-[#00755C] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0  active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]">
                친구 목록
            </button>

            {/* <button type="button" class="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 shadow-lg shadow-green-500/50 dark:shadow-lg dark:shadow-green-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2">
                Green
            </button> */}

        </>
    )
}

export default ButtonRight